// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__2q5jM","logo":"Nav_logo__1Xgvm"};